import { createSearchSortContext } from "@/components/Search/create-search-sort-context";

// i18n-tasks-use t('components.views.shared.marketplace_search.sort_most_relevant')
// i18n-tasks-use t('components.views.shared.marketplace_search.sort_price_low_high')
// i18n-tasks-use t('components.views.shared.marketplace_search.sort_price_high_low')
// i18n-tasks-use t('components.views.shared.marketplace_search.sort_top_reviewed')
// i18n-tasks-use t('components.views.shared.marketplace_search.sort_newest')
const SORT_KEYS = [
  { value: "listings", labelKey: "components.views.shared.marketplace_search.sort_most_relevant" },
  { value: "listings_price_asc", labelKey: "components.views.shared.marketplace_search.sort_price_low_high" },
  { value: "listings_price_desc", labelKey: "components.views.shared.marketplace_search.sort_price_high_low" },
  { value: "listings_top_reviewed", labelKey: "components.views.shared.marketplace_search.sort_top_reviewed" },
  { value: "listings_newest", labelKey: "components.views.shared.marketplace_search.sort_newest" },
] as const;

export const { SortProvider: MarketplaceSortProvider, useSort: useMarketplaceSort } = createSearchSortContext(
  "Marketplace",
  SORT_KEYS,
);
